module.exports = "<div ng-controller=\"ProjectAdvanceController as pa\" class=\"pa-unavailable-container\">\n    <p>\n        Advance payment is not available for this project.\n    </p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceUnavailable.html
// module id = 266
// module chunks = 1